import Modal from "@/common/elements/Modal";
import Table from "@/common/elements/Table";
import dayjs from "dayjs";
import { RowCount } from "./style";
import {
  buildInmateTrackingDestination,
  buildInmateTrackingSummary,
} from "@/util/inmateTrackingSummary";

const HouseAndTracksInfoTables = ({ showLogInfo, setShowLogInfo, data }) => {
  const tableHeaders = [
    { key: "status", text: "Status" },
    { key: "scheduledDate", text: "Scheduled" },
    { key: "actualDate", text: "Actual" },
    { key: "movedTo", text: "Moved To" },
    { key: "summary", text: "Summary" },
  ];

  return (
    <Modal
      header={"Movement Logs"}
      show={showLogInfo}
      size="xl"
      onHide={() => setShowLogInfo(false)}
      footerActionsNeed={false}
    >
      <Table
        headers={tableHeaders}
        data={data?.map((detail) => ({
          status: detail?.movementStatus,
          scheduledDate: detail?.scheduledDate
            ? dayjs(`${detail?.scheduledDate} ${detail?.scheduledTime}`).format(
                "MM/DD/YYYY HH:mm"
              )
            : null,
          actualDate: detail?.actualDate
            ? dayjs(`${detail?.actualDate} ${detail?.actualTime}`).format(
                "MM/DD/YYYY HH:mm"
              )
            : dayjs().format("MM/DD/YYYY HH:mm"),
          movedTo: buildInmateTrackingDestination(detail),
          summary: buildInmateTrackingSummary(detail),
        }))}
      />
      <RowCount>
        <div className="row-count">Total Number of Rows : {data?.length}</div>
      </RowCount>
    </Modal>
  );
};

export default HouseAndTracksInfoTables;
